<template>
    <div>
        <header3 :title="title" />
        <div class = "content_obnovitdate" v-if="!loading" >
            <div v-if="!free">
                <div class="titleviptop"><span >Обновить дату объявления на текущую.</span></div>
                <div class="titleviptop"><span >Бесплатно 1 раз в 14 дней.</span></div>
                <div class="textfree"><span >{{ text_free }}</span></div>
                <hr/>
                <table width="80%">
                    <tr>
                        <td><div class="textcomment"><span >В кошельке:</span></div></td>
                        <td align="right"><div class="textbalans" ><span >{{ balans }} c.</span></div></td>
                    </tr>
                </table>
                <hr/>
                <table width="80%">
                    <tr>
                        <td><div class="textcomment"><span >К оплате:</span></div></td>
                        <td align="right"><div class="textbalans" ><span >{{ senaobnovitdate }} c.</span></div></td>
                    </tr>
                </table>
                <hr/>
                <div class="titleviptop"><span >Все налоги включены</span></div>
            </div>


            <div class="textfree" v-if="free">
                <br/><br/>
                <span >Бесплатное обновление доступно сейчас.</span>
                <br/><br/>
            </div>
            
            <div><button class = "buttonviptop" @click="funcobnovitdate()">Обновить дату</button></div>

        </div>
        <br/><br/><br/><br/>
        <div v-if="loading" align="center"><Spinner /></div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import header3 from "../blocks/header3";
  import Spinner from "../blocks/spinner";
  export default {
     components:{
        header3, Spinner,
     },
    data() {
      return {
        id:0,
        title:"Обновить дату",
        senaobnovitdate:0,
        balans:0,
        free:false,
        text_free:"Бесплатное обновление доступно через 12 дней 22 часа.",
        loading:false,

      
      };
    },
    methods: {
        getinfoobnovitdate(){
        this.loading = true;
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/getInfoObnovitDate",
          data: {
            token: localStorage.getItem("token"),
            id: this.id,
          },
        })
          .then((res) => {
            if (res.data.status) {
               this.loading=false;
               this.senaobnovitdate=res.data.senaobnovitdate;
               this.balans=res.data.balans;
               this.text_free = res.data.infofreeobnovitdate;
               this.free=res.data.free;
            }else alert("Error") 
          })
          .catch((error) => {
            if (!error.response) {
              alert("Error")
            }
          });
       },


       funcobnovitdate(){
         if(this.free){
            this.obnovitdate();
         }else{
            if(this.senaobnovitdate > this.balans){
                this.$router.push({ name: "fillupbalans" });
            }else{
                this.obnovitdate(); 
            }
         }
       },

       obnovitdate(){
        this.loading = true;
        axios({
          method: "post",
          url: "https://avtobaza.tj/api/ObnovitDateObv",
          data: {
            id: this.id,
            token: localStorage.getItem("token"),

          },
        })
          .then((res) => {
            if (res.data.status) {
               this.loading=false;
               localStorage.removeItem("idviptop");
               localStorage.setItem ("restart",true);
               this.$router.go(-1);
            }else alert("Error") 
          })
          .catch((error) => {
            if (!error.response) {
              alert("Error")
            }
          });
       }

    },
    created() {
      if (!localStorage.getItem("token")) {
         this.$router.go(-1); 
        }else{
            if(localStorage.getItem("idobnovitdate")){
              this.id=localStorage.getItem("idobnovitdate");
              this.getinfoobnovitdate();
            }else this.$router.go(-1); 
        } 
    },
    mounted (){
     
    }
  };
  </script>
  <style scoped>
  .content_obnovitdate{
    width: 100%;
    max-width: 400px;
    margin-top: 60px;
    padding-top: 20px;
    margin-bottom: 20px;
    
  }
  .titleviptop{
    margin-top: 5px;
    color: #000;
    font-size: 18px;
  }
  .buttonviptop{
    background: none;
    background-color: #0b76ef;
    padding: 14px 12px;
    border: none;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    width: 100%;
  }
  .buttonviptop:hover{
    background-color: #1381fd;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0);
    cursor: pointer;
  }
  .textfree{
    margin-top: 5px;
    color: #20b867;
    font-size: 18px;
  }
  .textcomment{
    color: #666;
    font-size: 18px;
  }
  .textbalans{
    color: #000;
    font-size: 18px;
  }
  </style>